module.exports = __webpack_public_path__ + "static/media/date.fb109c35.svg";